import { useParams } from "react-router-dom";
import {
  Analysis,
  FireEyeNetworks,
  JoeNetworks,
  Schema
} from "../../../../@types";
import { CapeNetworks } from "../../../../@types/cape/";
import { CuckooNetworks } from "../../../../@types/cuckoo";
import DynamicAnalysisGrid from "../DynamicAnalysisGrid";
import { useGetNetworkData } from "../hooks";

interface Props<T> {
  analysis: Analysis;
  type: T;
  schema: Schema<unknown>;
}

const NetworkGrid = <
  T extends CapeNetworks | CuckooNetworks | FireEyeNetworks | JoeNetworks
>({
  type,
  schema,
  analysis
}: Props<T>) => {
  const { hash, uploadId } = useParams();
  const { data } = useGetNetworkData(hash, type, analysis, uploadId);

  return <DynamicAnalysisGrid data={data} schema={schema} />;
};

export default NetworkGrid;
